import React, { useState } from 'react';
import MarkdownContent from '../components/MarkdownContent';
import Quiz from './Quiz';

const EducationPage = () => {
  const [currentModule, setCurrentModule] = useState('1_introduction_to_sabr.md');

  // MODIFICATION: The full, original list of modules is now included.
  const modules = [
      { id: '1_introduction_to_sabr.md', title: '1. Introduction to SABR' },
      { id: '2_radiobiological_principles.md', title: '2. Radiobiological Principles' },
      { id: '3_patient_selection_&_clinical_indications.md', title: '3. Patient Selection & Indications' },
      { id: '4_imaging_&_simulation.md', title: '4. Imaging & Simulation' },
      { id: '5_target_&_volume_definitions.md', title: '5. Target & Volume Definitions' },
      { id: '6_motion_management.md', title: '6. Motion Management' },
      { id: '7_treatment_planning.md', title: '7. Treatment Planning' },
      { id: '8_plan_quality_metrics.md', title: '8. Plan Quality Metrics' },
      { id: '9_site_specific_planning.md', title: '9. Site-Specific Planning' },
      { id: '10_treatment_delivery_verification.md', title: '10. Delivery & Verification' },
      { id: '11_unique_challenges.md', title: '11. Unique Challenges' },
      { id: '12_clinical_outcomes_&_evidence.md', title: '12. Clinical Outcomes & Evidence' },
      { id: '13_future_directions.md', title: '13. Future Directions' },
      { id: 'quiz', title: '14. SABR Competency Quiz' }, 
      { id: '15_glossary.md', title: '15. Glossary' },
      { id: '16_references.md', title: '16. References' },
  ];

  return (
    <div className="page-content p-4 md:p-6">
      <div className="text-center mb-8">
          <h1 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-cyan-400 mb-2">SABR Education Modules</h1>
          <p className="text-gray-600 dark:text-gray-400 text-base md:text-lg">Learn the core principles of Stereotactic Ablative Body Radiotherapy.</p>
      </div>
      <div className="flex flex-col md:flex-row gap-8">
        <aside className="md:w-1/4">
          <h3 className="text-lg font-bold text-gray-800 dark:text-gray-200 mb-4">Modules</h3>
          <ul className="space-y-2">
            {modules.map(module => (
              <li key={module.id}>
                <button 
                  onClick={() => setCurrentModule(module.id)}
                  className={`w-full text-left px-4 py-2 rounded-lg transition-colors duration-200 ${currentModule === module.id ? 'bg-blue-600 text-white font-semibold' : 'hover:bg-gray-200 dark:hover:bg-gray-700'}`}
                >
                  {module.title}
                </button>
              </li>
            ))}
          </ul>
        </aside>
        <main className="flex-1 bg-gray-50 dark:bg-gray-800 p-6 rounded-lg border dark:border-gray-700">
          {currentModule === 'quiz' ? <Quiz /> : <MarkdownContent file={currentModule} />}
        </main>
      </div>
    </div>
  );
};

export default EducationPage;